/** Talk's and Find's chats: the list of past chats, a new chat, and deleting one. */
export const chats = {
    "chats.new": "New chat",
    "chats.title": "Your chats",
    "chats.today": "Today",
    "chats.yesterday": "Yesterday",
    "chats.earlier": "Earlier",
    "chats.empty": "No past chats yet. Every chat is kept here, on this phone.",
    "chats.kept": "Only on this phone. The newest {count} chats are kept; someone else signing in here sees none of them.",
    "chats.untitled": "Untitled chat",
    "chats.card_waiting": "Your card is not finished",
    "chats.delete": "Delete",
    "chats.delete_label": "Delete chat: {title}",
    "chats.delete_confirm": "Delete this chat? It is removed from this phone for good.",
    "chats.delete_confirm_card": "Delete this chat? It is removed from this phone, with your unfinished card's answers.",
    "chats.delete_yes": "Delete",
    "chats.keep": "Keep it",
    "chats.need_unsent": "Not sent to workers yet",
    "chats.delete_confirm_sent": "Delete this chat? It is removed from this phone for good; its job stays in My jobs.",
    "chats.new_need": "Ask for something else",
};
//# sourceMappingURL=chats.js.map